export const BOLLYWOOD_ID = 'bollywood';
export const BELLYDANCE_ID = 'bellydance';
export const UYGHUR_ID = 'uyghur';
